import * as React from 'react'
import {useState} from 'react'
import {observer} from 'mobx-react'
import {
  OverlayBlockWrapper,
  OverlayBlockWrapperProps,
} from '../../../lib/OverlayBlockWrapper'
import {OverlaySmsPollCountdown} from './elements/OverlaySmsPollCountdown'
import {OverlaySmsPollChangeNumber} from './elements/OverlaySmsPollChangeNumber'

///////////////////////////////////////////////////////////////////////////////

export enum SmsPollView {
  COUNTDOWN = 'countdown',
  CHANGE_NUMBER = 'change_number',
}

///////////////////////////////////////////////////////////////////////////////

export const OverlaySmsPollBlock = observer(() => {
  const [view, changeView] = useState(SmsPollView.COUNTDOWN)
  const overlayProps: OverlayBlockWrapperProps = {
    showHeader: false,
    closeOnClickOutside: false,
    closeOnEsc: false,
    className: 'overlay-sms-poll-block',
  }
  const showCountdown = view === SmsPollView.COUNTDOWN
  const showChangeNumber = view === SmsPollView.CHANGE_NUMBER

  return (
    <OverlayBlockWrapper {...overlayProps}>
      {showCountdown && <OverlaySmsPollCountdown changeView={changeView} />}
      {showChangeNumber && <OverlaySmsPollChangeNumber />}
    </OverlayBlockWrapper>
  )
})
